import React from 'react';
import styled from '@emotion/styled';
import { __ } from '../../../../utils/translation-service';
import { color, screenSize } from './variables';
import { post } from '../header-mobile-old/http';
import { log } from '../../../../utils/logger';
import { LocaleConfigContext } from '../../../../contexts/locale-config/locale-config';
import { ILocaleConfig } from '@interfaces';

const FormWrapper = styled.form`
    border: 1px solid ${color.darkGrey2};
    float: right;
    width: 186px;
    margin: 1px 13px 0;
    padding: 1px 0;

    @media (min-width: ${screenSize.lg}) {
        padding: 0;
        margin: 10px 0 10px 10px;
        width: 183px;
        border-color: ${color.white};
    }

    input {
        border: 0;
        padding: 1px 7px;
        background: transparent;
        font-size: 13px;
        color: ${color.darkGrey3};
        width: 153px;

        @media (min-width: ${screenSize.lg}) {
            width: 150px;
            padding: 5px 7px;
            color: ${color.lightGrey4};
        }

        &::-webkit-input-placeholder {
            color: ${color.darkGrey3};
            font-size: 13px;

            @media (min-width: ${screenSize.lg}) {
                color: ${color.lightGrey4};
            }
        }
        &:-moz-placeholder {
            color: ${color.darkGrey3};
            font-size: 13px;

            @media (min-width: ${screenSize.lg}) {
                color: ${color.lightGrey4};
            }
        }
        &::-moz-placeholder {
            color: ${color.darkGrey3};
            font-size: 13px;

            @media (min-width: ${screenSize.lg}) {
                color: ${color.lightGrey4};
            }
        }
        &:-ms-input-placeholder {
            color: ${color.darkGrey3};
            font-size: 13px;

            @media (min-width: ${screenSize.lg}) {
                color: ${color.lightGrey4};
            }
        }
    }
    button {
        border: 0;
        background: transparent;
        height: 16px;

        @media (min-width: ${screenSize.lg}) {
            height: auto;
        }
        &:before {
            color: ${color.darkGrey3};
            font-size: 14px;

            @media (min-width: ${screenSize.lg}) {
                color: ${color.lightGrey4};
            }
        }
    }
`;
interface IState {
    cruiseNid: string;
}

interface IProps {
    className: string;
}

export class SearchCruise extends React.Component<IProps, IState> {
    static contextType = LocaleConfigContext;

    declare context: React.ContextType<typeof LocaleConfigContext>;

    public constructor(props: IProps) {
        super(props);
        this.state = {
            cruiseNid: '',
        };
    }

    public handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const re = /^[0-9\b]+$/;
        if (e.target?.value === '' || re.test(e.target.value)) {
            this.setState({ cruiseNid: e.target.value });
        }
    };

    public handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const localeConfig: ILocaleConfig = this.context;

        const brand = localeConfig.code === 'au' ? 'cruiseaway' : localeConfig.code;
        const apiHost = `https://backend.dreamlines.com/${brand}`;
        const slugs = [
            {
                slugName: 'searchresults',
                slugValue: localeConfig.slugs.search,
            },
        ];
        const contentEndpoint = `https://www.${localeConfig.url}`;
        const url = `${apiHost}/cruises/search`;
        const searchSlug = slugs.find((item) => item.slugName === 'searchresults')?.slugValue;
        const urlNotFound = `${contentEndpoint}/${searchSlug}?cruiseNids=${this.state.cruiseNid}`;
        const searchParams = {
            filterParams: {
                cruiseNids: this.state.cruiseNid,
            },
            limit: 1,
            offset: 0,
            sortString: 'relevance',
            page: 1,
        };
        if (this.state.cruiseNid.length) {
            post(url, searchParams)
                .then((res) => {
                    const cruises = res.cruises;
                    if (cruises?.length) {
                        window.location.href = `${contentEndpoint}${cruises[0].cruisePageUrl}`;
                    } else {
                        window.location.href = urlNotFound;
                    }
                })
                .catch((error) => {
                    log.error('Handling submit in searchCruise Header page ', error);
                });
        }
    };

    public render() {
        return (
            <FormWrapper onSubmit={this.handleSubmit} className={this.props.className}>
                <input
                    type="text"
                    value={this.state.cruiseNid || ''}
                    onChange={this.handleChange}
                    placeholder={__('insertCruiseId')}
                />
                <button className="icon-magnifyingGlass" style={{ padding: '0 0 0 8px' }} />
            </FormWrapper>
        );
    }
}
